module.exports = "/dist/bc7fdc5d4bd61da9f8ba268a266649c8.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800italic.eot
// module id = 21
// module chunks = 0